export default {
  API_DOMAIN: process.env.REACT_APP_API_DOMAIN,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL,
  PAYMENT_REDIRECT_URL: process.env.REACT_APP_PAYMENT_REDIRECT_URL,
  DEPOSIT_REDIRECT_URL: process.env.REACT_APP_DEPOSIT_REDIRECT_URL,
  FPX_TERM_AND_CONDITIONS_LINK: process.env.REACT_APP_FPX_TERM_AND_CONDITIONS_LINK,
};
